import React, { useEffect } from "react";
import "./style.scss";
import { Link } from "react-router-dom";
// import ShowIcon from "../../../../assets/icons/arrow-down-blue.svg";

// import { capitalizeFirstLetter, convertToMillions } from "../../../../utils/helpers/string";

import { useDispatch } from "react-redux";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import right_tick from "../../assets/icons/yes_tick.svg";
import Card from "./Card";
import { setSelectedChallenge } from "../../utils/store/reducers/accountMetricsSlice";
import "react-loading-skeleton/dist/skeleton.css";
import { FormatUSD } from "../../utils/helpers/string";

function Tier({ tiers, activeTier, setActiveTier, setFooterValue }) {
  const challenges = tiers?.challenges;

  const tiersNew = [...challenges].sort(
    (a, b) => a?.starting_balance - b?.starting_balance
  );

  const dispatch = useDispatch();

  const planName = tiers?.name?.toLowerCase();
  const isInstantFunding = planName === "direct plan";
  const isZeroPlan = planName === "zero plan";
  const isPremiumPlan = planName === "premium plan";
  const isAdvancedPlan = planName === "advanced plan";

  const handleActive = (id) => {
    setActiveTier(id);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [tiers]);

  // Max Position (contracts) is derived from the challenge's position in the
  // ascending-balance list, and differs per plan.
  const getMaxPosition = (index) => {
    if (isInstantFunding) {
      return index === 0 ? 2 : index === 1 ? 4 : index === 2 ? 6 : 10;
    }
    if (isZeroPlan) {
      return index === 0 ? 1 : index === 1 ? 3 : 6;
    }
    if (isPremiumPlan) {
      return index === 0 ? 4 : index === 1 ? 8 : 12;
    }
    return index === 0
      ? 5
      : index === 1
        ? 10
        : index === 2
          ? 15
          : index === 3
            ? 20
            : 25;
  };

  const renderStandardRows = (newTiers, index) => (
    <>
      <div className="tier_val">
        <p className="heading">Starting Balance</p>
        <p>{FormatUSD(newTiers?.starting_balance) ?? "-"}</p>
      </div>
      <div className="tier_val">
        <p className="heading">Profit Share</p>
        <p>
          {isAdvancedPlan || isZeroPlan || isPremiumPlan ? "" : "up to "}
          {newTiers?.profit_share ?? "-"} %
        </p>
      </div>
      <div className="tier_val">
        <p className="heading">Profit Target</p>
        <p>{FormatUSD(newTiers?.profit_target_1) ?? "-"}</p>
      </div>
      <div className="tier_val">
        <p className="heading">Max Position</p>
        <p>
          {getMaxPosition(index)}
          &nbsp;Contracts
        </p>
      </div>
      <div className="tier_val">
        <p className="heading">Max Loss</p>
        <p>
          {FormatUSD(newTiers?.starting_balance * (newTiers?.max_loss / 100)) ??
            "-"}
        </p>
      </div>
      {/* Insert Max Daily Loss after Max Loss for Zero Plan */}
      {isZeroPlan && (
        <div className="tier_val">
          <p className="heading">Max Daily Loss</p>
          <p>
            {FormatUSD(
              newTiers?.starting_balance * (newTiers?.max_daily_loss / 100)
            ) ?? "-"}
          </p>
        </div>
      )}

      <div className="tier_val">
        <p className="heading">Payout</p>
        <p>
          {isAdvancedPlan || isZeroPlan || isPremiumPlan ? "Weekly" : "Biweekly"}
        </p>
      </div>
      <div className="tier_val">
        <p className="heading">Min Trading Days</p>
        <p>
          {newTiers?.min_trading_days ?? "0"} {isZeroPlan ? "day" : "days"}
        </p>
      </div>

      <div className="tier_val">
        <p className="heading">Micro Scaling</p>
        <p> {true ? <img src={right_tick} /> : "No"}</p>
      </div>
      <div className="tier_val">
        <p className="heading">Consistency Rule</p>
        <p>
          {isAdvancedPlan || isPremiumPlan ? (
            "Evaluation Only"
          ) : isZeroPlan ? (
            "Qualified Only"
          ) : (
            <img src={right_tick} />
          )}
        </p>
      </div>
    </>
  );

  const renderCard = (newTiers, index) => (
    <div className="tier_wrapper" key={index}>
      <div className="tier_upper">
        <div className="tier-type">
          <span>{`$${newTiers?.price}/month`}</span>
          {Number(newTiers?.price_2) > 0 && (
            <span className="no_activation_fee">
              {`$${newTiers?.price_2}/month (No Activation Fee)`}
            </span>
          )}
        </div>
        <div
          className="tier-price"
          style={{ display: "flex", alignItems: "center", gap: "10px" }}
        >
          <h3>${(newTiers?.starting_balance / 1000).toFixed(1)}k</h3>
          <span>Challenge</span>
        </div>

        <Link
          to={`/Assessments-checkout/${newTiers?.id}`}
          className="get_started_link"
        >
          <button
            className="get_started_btn"
            onClick={() => dispatch(setSelectedChallenge(newTiers?.id))}
          >
            Get Started
          </button>
        </Link>
      </div>
      <Card
        className={`tier-container ${
          tiers?.id === activeTier ? "tier-highlight" : ""
        }`}
        onClick={() => handleActive(tiers.id)}
      >
        <div className="tier-num">{renderStandardRows(newTiers, index)}</div>
      </Card>
    </div>
  );

  return (
    <>
      {tiersNew?.length > 3 ? (
        <Splide
          aria-label="My Favorite Images"
          options={{
            // type: "Loop",
            autoplay: true,
            pagination: false,
            perPage: 3,
            perMove: 1,
            width: "100%",
            drag: "free",
            gap: "10px",
            pauseOnHover: false,
            breakpoints: {
              1550: { perPage: 3, gap: "1rem" },
              1350: { perPage: 2, gap: "1rem" },
              970: { perPage: 1, gap: "1rem" },
            },
          }}
        >
          {tiersNew?.map((newTiers, index) => (
            <SplideSlide key={index}>{renderCard(newTiers, index)}</SplideSlide>
          ))}
        </Splide>
      ) : (
        tiersNew?.map((newTiers, index) => renderCard(newTiers, index))
      )}
    </>
  );
}

export default Tier;
